import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  bcpDataService,
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';

import controller from './delete-servers-dialog.controller';
import template from './delete-servers-dialog.html';

class dialogService {
  getOptions($event, { assessmentId, servers }) {
    return {
      controller,
      controllerAs: 'deleteServersDialogVM',
      locals: {
        assessmentId,
        servers
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.servers.deleteServersDialog', [
  ngCookies,
  constants,
  bcpDataService,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
])
  .service('deleteServersDialog', dialogService)
  .name;
